import React from 'react'
import { colors, LayoutBand, useContainerWidth, Grid, Card, Bleed } from '@fs/zion-ui'
import PlaceEditorTrainingHeader from './components/PlaceEditorTrainingHeader'
import PlaceEditorTrainingNav from './components/PlaceEditorTrainingNav'
import PlaceEditorTrainingContent from './components/PlaceEditorTrainingContent'

export default function PlaceEditorTrainingPage(): JSX.Element {
  const atWidth = useContainerWidth()
  const isMobile = atWidth({ default: true, lg: false })
  const leftNavColumns = atWidth({ default: 12, lg: 3 })
  const rightContentColumns = atWidth({ default: 12, lg: 9 })

  return (
    <LayoutBand
      maxWidth="xxl"
      marginY="nano"
      marginX="nano"
      id="place-editor-training-page"
      style={{ height: 'calc(100vh - 70px)', background: colors.gray02 }}
    >
      <Grid gutters="xxs">
        <Card columns={12} margins="dense">
          <PlaceEditorTrainingHeader />
        </Card>
        {!isMobile && (
          <Card columns={leftNavColumns} margins="dense">
            <Bleed top>
              <PlaceEditorTrainingNav />
            </Bleed>
          </Card>
        )}
        <Card columns={isMobile ? 12 : rightContentColumns} margins="dense">
          <Bleed top>
            <PlaceEditorTrainingContent />
          </Bleed>
        </Card>
      </Grid>
    </LayoutBand>
  )
}
